import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { selectAuth } from '@app/features/auth/auth.selectors';
import {
  AppAccessRequirement,
  hasRequiredAccess,
} from '@core/models/app-navigation.model';
import { Store } from '@ngrx/store';
import { filter, map, Observable, take } from 'rxjs';

import { IAuthState } from '@app/features/auth/auth.reducer';

const selectSettledAuth = (): Observable<IAuthState> =>
  inject(Store)
    .select(selectAuth)
    .pipe(
      filter(
        (auth) =>
          auth.init &&
          !auth.sessionTransitioning &&
          (auth.accessStatus === 'ready' || auth.accessStatus === 'failed'),
      ),
      take(1),
    );

export const appAccessAvailabilityGuard: CanActivateFn = () => {
  const router = inject(Router);

  return selectSettledAuth().pipe(
    map((auth) =>
      auth.accessStatus === 'failed'
        ? router.parseUrl('/access-unavailable')
        : true,
    ),
  );
};

export function getAppAccessGuard(
  requirement: AppAccessRequirement,
  redirectTo = '/forbidden',
): CanActivateFn {
  return () => {
    const router = inject(Router);

    return selectSettledAuth().pipe(
      map((auth) => {
        if (auth.accessStatus === 'failed') {
          return router.parseUrl('/access-unavailable');
        }

        return hasRequiredAccess(auth.access, requirement)
          ? true
          : router.parseUrl(redirectTo);
      }),
    );
  };
}
